var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedWavy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Red Wave Line") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CAP4---Enhancements-to-SpaceCraft-Web-13Jun2020-UZ-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.26---1",
    transform: "translate(-220.000000, -212.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(211.000000, 79.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(1.000000, 66.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tool-List-Item-Copy-3",
    transform: "translate(0.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(8.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    opacity: 0.0138346354,
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.56066017,-2 L7.56066017,1.34095146 C7.56066017,1.76899659 7.69799045,2.18574975 7.95246098,2.52994067 L8.34099026,3.05545635 C8.78949706,3.66209624 8.72664142,4.50559163 8.19317619,5.03905686 L8.06066017,5.17157288 C7.47487373,5.75735931 7.47487373,6.70710678 8.06066017,7.29289322 C8.64644661,7.87867966 8.64644661,8.82842712 8.06066017,9.41421356 C7.47487373,10 7.47487373,10.9497475 8.06066017,11.5355339 L8.37916712,11.8540409 C8.76793303,12.2428068 8.76793303,12.8731209 8.37916712,13.2618868 C8.36676277,13.2742911 8.3540327,13.2863654 8.34099026,13.298097 L8.22314568,13.4040976 C7.80146752,13.783395 7.56066017,14.3238918 7.56066017,14.8910593 L7.56066017,18",
    id: "Path-2",
    stroke: "#D0021B",
    transform: "translate(8.060660, 8.000000) rotate(-315.000000) translate(-8.060660, -8.000000) "
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedWavy);
export default __webpack_public_path__ + "static/media/redWavy.6f9449ebaacbb2ca8aa06767553d5955.svg";
export { ForwardRef as ReactComponent };